import { api } from './client';

/**
 * Superadmin Direct Leave & Balance API client
 */

export async function superadminListLeaves(employeeId) {
  try {
    const params = employeeId ? { employeeId } : {};
    const res = await api.get('/leave/superadmin/leaves', { params });
    const data = res.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.content)) return data.content;
    return [];
  } catch (err) {
    // Graceful fallback to /leave/all in case user has ADMIN role
    const fallbackRes = await api.get('/leave/all', { params: { size: 500 } });
    const data = fallbackRes.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.content)) return data.content;
    return [];
  }
}

export async function superadminUpdateLeave(id, patch) {
  const res = await api.put(`/leave/superadmin/leaves/${id}`, patch);
  return res.data?.data || res.data;
}

export async function superadminDeleteLeave(id) {
  const res = await api.delete(`/leave/superadmin/leaves/${id}`);
  return res.data;
}

export async function superadminGetBalances(employeeId) {
  const res = await api.get('/leave/superadmin/balances', { params: { employeeId } });
  const data = res.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  return [];
}

export async function superadminUpsertBalance(payload) {
  const res = await api.put('/leave/superadmin/balances', payload);
  return res.data?.data || res.data;
}

export async function approveLeave(leaveId, status, remarks) {
  const res = await api.put('/leave/approve', { leaveId, status, remarks });
  return res.data?.data || res.data;
}

export async function reverseLeaveRejection(leaveId, remarks = '') {
  const res = await api.put(`/leave/${leaveId}/reverse-rejection`, { remarks });
  return res.data?.data || res.data;
}

export async function remindLeaveManager(leaveId) {
  const res = await api.post(`/leave/${leaveId}/remind-manager`);
  return res.data;
}

export async function getEmployeeMonthlyBalance(employeeId, year) {
  try {
    const res = await api.get(`/leave/subordinate/${employeeId}/monthly-balance/${year}`);
    return res.data?.data || res.data;
  } catch (err) {
    // Try single balance
    const alt = await api.get(`/leave/balance/${employeeId}/${year}`);
    return { currentAvailableBalance: alt.data, totalPaidLeavesAvailableYear: alt.data };
  }
}

/**
 * Fetch monthly leave summary for all employees (for HR & Super Admin payroll readiness)
 */
export async function getMonthlyLeaveSummary(month, year) {
  const res = await api.get(`/leave/summary/monthly/${month}/${year}`);
  return res.data?.data || res.data;
}
